module.exports = __webpack_public_path__ + "static/img/typescript.3e7cca49.svg";